import type {Schedule} from '../types/domain'

const storageKey = 'failed-schedule-draft'

export interface FailedScheduleDraft {
  ownerUid: string
  originalName: string
  values: Schedule
  dismissed: boolean
}

export function readFailedScheduleDraft(ownerUid: string | undefined, originalName: string): FailedScheduleDraft | null {
  try {
    const draft = JSON.parse(sessionStorage.getItem(storageKey) ?? 'null')
    if (!ownerUid || draft?.ownerUid !== ownerUid || draft.originalName !== originalName) return null
    const values = draft.values
    if (typeof values?.name !== 'string' || !['blinds', 'breaks', 'chips'].every(key =>
      Array.isArray(values[key]) && values[key].every((entry: unknown) => entry !== null && typeof entry === 'object'))) return null
    return draft
  } catch {
    return null
  }
}

export function writeFailedScheduleDraft(draft: FailedScheduleDraft): boolean {
  try {
    sessionStorage.setItem(storageKey, JSON.stringify(draft))
    return true
  } catch {
    return false
  }
}

export function clearFailedScheduleDraft(ownerUid: string | undefined, originalName: string): void {
  if (!readFailedScheduleDraft(ownerUid, originalName)) return
  try {
    sessionStorage.removeItem(storageKey)
  } catch {
    // The confirmed backend save remains successful when browser storage is unavailable.
  }
}
